import userStatus from './userStatus.vue'

export default userStatus
